import { GraduationCap, ExternalLink, BookOpen, Users, Headphones } from 'lucide-react';

const RESOURCES = [
  { title: "Learn Sitar Online", icon: GraduationCap, desc: "Comprehensive online courses from beginner to advanced, taught by experienced gurus.", links: ["Ali Akbar College of Music", "Sitar School Online", "Coursera Indian Music"] },
  { title: "Sheet Music & Notations", icon: BookOpen, desc: "Access traditional bandish notations, raga compositions, and taal patterns for sitar practice.", links: ["Raga Guide Database", "SwarShala Notations", "ITCSRA Archives"] },
  { title: "Community & Forums", icon: Users, desc: "Connect with fellow sitar enthusiasts, students, and performers worldwide.", links: ["Sitar Forum", "Reddit r/sitar", "Facebook Sitar Community"] },
  { title: "Listening Library", icon: Headphones, desc: "Curated playlists and archives of legendary sitar performances spanning decades.", links: ["Spotify Sitar Classics", "Archives of Indian Music", "All India Radio Archives"] },
];

export default function ResourcesSection() {
  return (
    <section id="resources" data-testid="resources-section" className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.2em] text-[#d4af37] mb-4 flex items-center justify-center gap-2">
            <GraduationCap className="w-4 h-4" /> Learn & Connect
          </p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#fdfbf7] mb-4 tracking-tight">
            Resources & Community
          </h2>
          <p className="text-[#a3b1c6] max-w-xl mx-auto text-base">
            Everything you need to deepen your sitar journey
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {RESOURCES.map((res) => {
            const Icon = res.icon;
            return (
              <div
                key={res.title}
                data-testid={`resource-card-${res.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="bg-[#122036] border border-[#d4af37]/20 rounded-xl p-8 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(212,175,55,0.1)] transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-[#d4af37]/10 border border-[#d4af37]/20 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#d4af37]" />
                  </div>
                  <h3 className="font-['Cormorant_Garamond'] text-2xl text-[#fdfbf7]">{res.title}</h3>
                </div>
                <p className="text-[#a3b1c6] text-sm leading-relaxed mb-5">{res.desc}</p>
                <ul className="space-y-2">
                  {res.links.map((link) => (
                    <li key={link} className="flex items-center gap-2 text-sm text-[#d4af37] hover:text-[#e5c35b] cursor-pointer transition-colors">
                      <ExternalLink className="w-3 h-3" />
                      {link}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      <div className="section-divider mt-24 md:mt-32 max-w-4xl mx-auto" />
    </section>
  );
}
